export const childrenPaths = [
  {
    path: '/company/:id/general',
    name: 'Practice General',
    meta: {
      menuTitle: 'General',
      title: 'Company',
      icon: 'bhi-home',
      requiresAuth: true,
      disableLink: true,
    },
    component: () => import('@/views/practices/PracticeGeneral.vue'),
  },
  {
    path: '/company/:id/staff',
    name: 'Practice Staff',
    meta: {
      menuTitle: 'Team',
      title: 'Team',
      icon: 'bhi-pulse',
      requiresAuth: true,
      disableLink: true,
    },
    component: () => import('@/views/practices/PracticeUsers.vue'),
  },
  {
    path: '/company/:id/participants',
    name: 'Practice Participants',
    meta: {
      menuTitle: 'Participants',
      title: 'Participants',
      icon: 'bhi-account-multiple',
      requiresAuth: true,
      disableLink: true,
    },
    component: () => import('@/views/practices/PracticePatients.vue'),
  },
  {
    path: '/company/:id/programs',
    name: 'Practice Programs',
    meta: {
      menuTitle: 'Programs',
      title: 'Programs',
      icon: 'bhi-filter',
      requiresAuth: true,
      disableLink: true,
    },
    hideOnRole: [1, 2, 3, 5, 6, 7],
    hideOnRoleAlsoAdmins: true,
    component: () => import('@/views/practices/PracticePrograms.vue'),
  },
]

export default [
  {
    path: '/company',
    name: 'Practices',
    meta: {
      title: 'Company',
      icon: 'bhi-office',
      requiresAuth: true,
    },
    hideOnRole: 7,
    component: () => import('@/views/Practices.vue'),
  },
  {
    path: '/company/:id',
    name: 'Practice',
    hidden: true,
    meta: {
      title: 'Company',
      requiresAuth: true,
    },
    redirect: {
      name: 'Practice General',
    },
    component: () => import('@/views/Practice.vue'),
    children: childrenPaths,
  },
]
